export default __webpack_public_path__ + "static/media/IbdcLogo.648ac43f.png";